export function isRegexValid(input: string): boolean {
  if (!input) return false;
  const match = input.match(/^\/(.*)\/([a-z]*)$/);
  let pattern = input,
    flags = '';

  if (match) {
    pattern = match[1];
    flags = match[2];
  }
  try {
    new RegExp(pattern, flags);
    return true;
  } catch (e) {
    return false;
  }
}
